import { commentsTargetNotificationSetting } from "../commentsTargetNotificationSetting";
import type { AllRouteEndpoints } from "../routeTypes";

export const commentsTargetGlobalNotificationSettingCacheKeys: AllRouteEndpoints[] = [
  commentsTargetNotificationSetting,
];
